// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3cQ94","calendarButtons":"ClockData_calendarButtons__3HU79"};